import React from 'react'

import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'

import './ResultPageLink.scss'

export type ResultPageLinkProps = {
  insuranceClaim?: {
    services: Array<{
      metadata?: Record<string, any>
    }>
  } | null
}

export const ResultPageLink = ({ insuranceClaim }: ResultPageLinkProps) => {
  const b = bemJoin('result-page-link')
  const { formatMessage } = useIntl()

  const serviceWithResultPageUrl = insuranceClaim?.services.find(
    (service) => !!service.metadata && !!service.metadata['resultPageLink']
  )

  if (!serviceWithResultPageUrl) {
    return null
  }

  return (
    <div className={b()}>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={serviceWithResultPageUrl.metadata!['resultPageLink']}
      >
        {formatMessage({ id: 'Check.ResultPageLink.Link' })}
      </a>
    </div>
  )
}
